module.exports = __webpack_public_path__ + "static/media/rajkot.2ea3b531.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/backs/rajkot.jpg
// module id = 1009
// module chunks = 0